export default {
  title: 'Historia edycji menu',
  subtitle: 'Sprawdź, kto i kiedy zmienił ceny, dostępność i widoczność dla {{company}}.',
  filters: {
    type: {
      label: 'Typ',
    },
    item: {
      placeholder: 'Wszystkie pozycje',
    },
    event: {
      label: 'Zdarzenie',
    },
  },
  columns: {
    when: 'Kiedy',
    who: 'Zmienił(a)',
    type: 'Typ',
    item: 'Pozycja',
    event: 'Zdarzenie',
    changes: 'Zmiany',
  },
  types: {
    product: 'Produkt',
    modifier: 'Modyfikator',
    category: 'Kategoria',
    modifier_group: 'Grupa modyfikatorów',
    menu: 'Menu',
  },
  events: {
    created: 'Utworzono',
    updated: 'Zaktualizowano',
    deleted: 'Usunięto',
  },
  fields: {
    name: 'Nazwa',
    description: 'Opis',
    price: 'Cena',
    is_available: 'Dostępność',
    is_visible: 'Widoczność',
    is_available_for_pickup: 'Dostępność odbioru',
    is_available_for_delivery: 'Dostępność dostawy',
    tax_category_id: 'Kategoria podatkowa',
    schedule: 'Godziny wyświetlania',
    is_required: 'Wymagane',
    max_count: 'Maks. liczba wyborów',
  },
  // A dish's price per order method that a price change worked out again (QA24): each its own line.
  order_method_prices: {
    pickup: 'Cena odbioru osobistego',
    delivery: 'Cena dostawy',
    dine_in: 'Cena na miejscu',
    room_service: 'Cena obsługi pokoju',
  },
  booleans: {
    on: 'Dostępne',
    off: 'Niedostępne',
    yes: 'Tak',
    no: 'Nie',
  },
  schedule: {
    always: 'Zawsze',
    every_day: 'Codziennie',
  },
  pagination: {
    previous: 'Poprzedni',
    next: 'Następny',
  },
  causers: {
    undo: 'Cofnij',
    orders_terminal: 'Terminal zamówień',
    approved_by: {
      amigo: 'Amigo, zatwierdzone przez {{name}}',
      assistant: 'Asystent, zatwierdzone przez {{name}}',
    },
  },
  // Only our team sees it (the Amigo log is FoodAmigos-internal).
  open_agent_log: 'Otwórz w dzienniku Amigo',
  system: 'System',
  empty_value: '—',
  toasts: {
    failed_to_load_data: 'Nie udało się załadować historii edycji menu',
  },
};
